import React, { useLayoutEffect, useState } from 'react';

import * as S from '~/components/toasts-layout/ToastsLayout.styled';
import { Toast } from '~/stores/use-toasts/useToasts';

export interface DisplayToast {
  toast: Toast;
  exiting: boolean;
  displayIndex: number;
}

export interface ToastItemProps {
  displayToast: DisplayToast;
  $offsetY: number;
}

export const ToastItem = React.forwardRef<HTMLDivElement, ToastItemProps>(
  ({ displayToast, $offsetY }, ref) => {
    const { toast, exiting } = displayToast;
    const [enterFrom, setEnterFrom] = useState(!exiting);

    useLayoutEffect(() => {
      if (exiting || !enterFrom) return;
      const raf = requestAnimationFrame(() => setEnterFrom(false));
      return () => cancelAnimationFrame(raf);
    }, [enterFrom, exiting]);

    return (
      <S.Toast
        ref={ref}
        $offsetY={$offsetY}
        $position={toast.position}
        $enterFrom={enterFrom}
        $exiting={exiting}
        data-testid="global-toast"
      >
        {toast.content}
      </S.Toast>
    );
  }
);
